import api from "api";


export function getCallingKpiFilter() {
  return api.get(`/v1/kpi/coachDetailsFilters`);
}

export function getCallingKpiFilterApply(queryParams) {
  return api.get(`/v1/kpi/coachDetails` + queryParams);
}

export function getEngagementData(employeeUrl) {
  return api.get(employeeUrl);
}

export function getUserData(employeeUrl) {
  return api.get(employeeUrl);
}

export function getKpiHistoryData(queryParams) {
  return api.get(`/v1/kpi/historical_performance_summary_data`, { params: queryParams });
}

export function getKpiHistoryFilter() {
  return api.get(`/v1/kpi/getKpiHistoryFilter`);
}
